import { render, staticRenderFns } from "./InternalTransferStatus.vue?vue&type=template&id=1bed239c&scoped=true&"
import script from "./InternalTransferStatus.vue?vue&type=script&lang=js&"
export * from "./InternalTransferStatus.vue?vue&type=script&lang=js&"
import style0 from "./InternalTransferStatus.vue?vue&type=style&index=0&id=1bed239c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed239c",
  null
  
)

export default component.exports